import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/follow_record_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  keyword: {
    model_name: 'FollowRecord',
    column_type: 'string',
    column_name: 'content',
  },
  customer_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'FollowRecord',
  },
  customer: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'FollowRecord',
  },
  user_id_eq: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'FollowRecord',
  },
  user: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'FollowRecord',
  },
  followed_at_gteq: {
    column_type: 'datetime',
    model_name: 'FollowRecord',
    column_name: 'followedAt',
  },
  followed_at_lteq: {
    column_type: 'datetime',
    model_name: 'FollowRecord',
    column_name: 'followedAt',
  },
  customer_level_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_level',
    extra: {
      model_name: 'CustomerLevel',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_level: {
    column_type: 'belongs_to',
    column_name: 'customer_level',
    extra: {
      model_name: 'CustomerLevel',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
}
export const formColumnsConfig = {
  'self': {
    'followed_at': { required: true, disabledUpdate: false },
    'content': { required: true, disabledUpdate: false },
    'follow_key_item_ids': { required: true, disabledUpdate: false },
    'media': { required: false, disabledUpdate: false },
    'task_assignment_id': { required: false, disabledUpdate: false },
    'customer_id': { required: true, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('FollowRecord', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('FollowRecord', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
